<template>
    <div>
        <Modal :show="showModal" :close="() => {}">
            <template #header>
                <h1 class="header">
                    {{ $t("down-payment.modal.header") }}
                </h1>
            </template>

            <template #body>
                <div class="body-text">
                    {{ $t("down-payment.modal.body", { amount: formattedAmount }) }}
                </div>
            </template>
        </Modal>
    </div>
</template>

<script>
    import Modal from "./Modal.vue"
    import { formatCurrency } from "@/util/currency"

    export default {
        name: "DownPaymentRequiredModal",
        components: {
            Modal,
        },
        props: {
            showModal: {
                type: Boolean,
                default: false,
            },

            amount: {
                type: Number,
            },
        },

        computed: {
            formattedAmount() {
                return formatCurrency(this.amount)
            },
        },
    }
</script>
